<template>
  <div :class="{'single-line':singleLine}" class="percent-field" v-html="formattedValue"></div>
</template>

<script>
export default {
  name: 'tablefield-percent',
  props: {
    data: {
      required: true
    },
    config: {
      required: false,
      default: () => {
      }
    },
    singleLine: {
      required: false,
      default: false
    }
  },
  computed: {
    formattedValue() {
      let formattedValue = '—'
      if (this.data || this.data === 0) {
        formattedValue = this.$options.filters.percent(
          this.data.toLocaleString('de-DE', {
            minimumFractionDigits: this._.get(this.config, 'decoratorOptions.format[2]', 2),
            maximumFractionDigits: this._.get(this.config, 'decoratorOptions.format[4]', 3),
          })
        )
      }
      return formattedValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldPercent.vue?033f40e2